export default "__VITE_ASSET__m6wPjghA__"